import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OrderTracking from "./Components/OrderTracking";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <Router>
      <div>
   
        <Toaster position="top-right" reverseOrder={false} />

        <Routes>

          <Route path="/:taskId" element={<OrderTracking />} />
          

          <Route path="/" element={<OrderTracking />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;